module.exports = __webpack_public_path__ + "img/step2.fb63a20e.png";